export { default as TimeseriesAggregationWidget } from "./timeseries_aggregation_widget";
export { default as WidgetEditTimeseriesAggregation } from "./timeseries_aggregation_widget_form";

import * as TimeseriesAggregationWidgetFactory from "./timeseries_aggregation_widget_factory";

export { TimeseriesAggregationWidgetFactory };
